module.exports = __webpack_public_path__ + "img/art_poster.9167562e.jpg";